var map = {
	"./1 (1).jpg": "kQri",
	"./1 (2).jpg": "N8+7",
	"./1 (3).jpg": "eCsa",
	"./1 (4).jpg": "pf58",
	"./1 (5).jpg": "Xq66",
	"./1 (6).jpg": "HNq/",
	"./1 (7).jpg": "42tb",
	"./fmw.jpg": "92Yv",
	"./foodmyway.jpg": "bCJU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DdlF";